import type { Components, Theme } from "@mui/material";

declare module "@mui/material/CircularProgress" {
	interface CircularProgressPropsColorOverrides {
		soft: true;
	}
}

declare module "@mui/material/LinearProgress" {
	interface LinearProgressPropsColorOverrides {
		starter: true;
		essentials: true;
		premium: true;
	}
}

export const MuiCircularProgress: Components<Theme>["MuiCircularProgress"] = {
	variants: [
		{
			props: {},
			style: {
				"& .MuiCircularProgress-circle": {
					strokeLinecap: "round",
				},
			},
		},
		{
			props: { color: "soft" },
			style: ({ theme }) => ({ color: theme.palette.text.soft }),
		},
	],
};

export const MuiLinearProgress: Components<Theme>["MuiLinearProgress"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				backgroundColor: theme.palette.muted.dark,
				borderRadius: theme.spacing(1),
				".MuiLinearProgress-bar": {
					borderRadius: theme.spacing(1),
				},
			}),
		},
	],
};
